export default __webpack_public_path__ + "static/media/Larsseit-Light.4f89d560.ttf";